import {svgIconWrapper} from '../svg-icon-wrapper';

import ShoppingCartRegular from './shopping-cart-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <ShoppingCartRegular {...props} />;
}

SvgComponent.iconName = 'shoppingCartRegular';

export const ShoppingCartRegularIcon = svgIconWrapper(SvgComponent);
